import type { MaterialInfo } from "@rogue/rackbuilder"
import { RackOptions } from "@/js/pages/product/rackbuilder/RackTypes"
export { getFlipX, getDepthInInches } from "../../ftAdjustments"

// Shared context passed to all Indy builder functions
export interface IndyContext {
  config: RackOptions
  materials: MaterialInfo
  left: boolean
}

// MARK: Config Helpers
export function is80Height(config: RackOptions): boolean {
  return config.height === '80'
}

export function is90Height(config: RackOptions): boolean {
  return config.height === '90'
}

export function is100Height(config: RackOptions): boolean {
  return config.height === '100'
}

export function is24Depth(config: RackOptions): boolean {
  return config.depth === '2'
}

export function is30Depth(config: RackOptions): boolean {
  return config.depth === '3'
}

export function is43Depth(config: RackOptions): boolean {
  return config.depth === '4'
}

export function isHalfRack(config: RackOptions): boolean {
  return !config.sixPost || !!config.isRhinoHalfRack
}

// MARK: Adjustment Helpers
export function getRotateYAdjustments(left: boolean): Array<{ type: 'rotate'; axis: 'Y'; amount: 180 }> {
  return left ? [] : [{ type: 'rotate', axis: 'Y', amount: 180 }]
}